export default __webpack_public_path__ + "media/images/favicon/apple-touch-icon-120x120-769e13d775f8ee01b96b777808505c62.png";